import { IErpDocStatus, IErpAddStockDocStatus, IErpDocStatusDisplay } from 'x/types/Erp'

/** Map สถานะเอกสาร → label/color/bg สำหรับ display (single source of truth) */
export const ERP_DOC_STATUS_MAP: Record<IErpDocStatus, IErpDocStatusDisplay> = {
  DRAFT: { label: 'แบบร่าง', color: 'muted.600', bg: 'muted.100' },
  AWAIT_APPROVAL: { label: 'รออนุมัติ', color: 'info.700', bg: 'info.100' },
  AWAIT_PAYMENT: { label: 'รอชำระ', color: 'warning.700', bg: 'warning.100' },
  OVERDUE: { label: 'เกินกำหนด', color: 'red.700', bg: 'red.100' },
  PAID: { label: 'ชำระแล้ว', color: 'success.700', bg: 'success.100' },
  AWAIT_RECEIPT: { label: 'รอรับใบเสร็จ', color: 'info.700', bg: 'info.100' },
  GOT_RECEIPT: { label: 'รับใบเสร็จแล้ว', color: 'success.700', bg: 'success.100' },
  VOIDED: { label: 'ยกเลิก', color: 'red.700', bg: 'red.100' },
}

/** สถานะที่ใช้ใน settings checkboxes (เติมสต๊อกจากเอกสาร) */
export const ADD_STOCK_SETTING_STATUSES: { value: IErpAddStockDocStatus; label: string }[] = [
  { value: 'AWAIT_PAYMENT', label: ERP_DOC_STATUS_MAP.AWAIT_PAYMENT.label },
  { value: 'GOT_RECEIPT', label: ERP_DOC_STATUS_MAP.GOT_RECEIPT.label },
]

/** Helper: ดึง display info จาก status string (รองรับค่าที่ไม่อยู่ใน map) */
export const getErpDocStatusDisplay = (status?: string): IErpDocStatusDisplay | null => {
  if (!status) return null
  return ERP_DOC_STATUS_MAP[status as IErpDocStatus] ?? { label: status, color: 'muted.600', bg: 'muted.100' }
}
